export default "__VITE_ASSET__2ZL$axhT__"